import { render, staticRenderFns } from "./voyageView.vue?vue&type=template&id=694a1dfa&scoped=true"
import script from "./voyageView.vue?vue&type=script&lang=js"
export * from "./voyageView.vue?vue&type=script&lang=js"
import style0 from "./voyageView.vue?vue&type=style&index=0&id=694a1dfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694a1dfa",
  null
  
)

export default component.exports